import styled from 'styled-components';
import { IC_LEFT_PAGINATION_ARROW, AJAX_LOADER } from '../../Assets/images';

export const SlickSliderStyled = styled.div`
  width: 100%;

  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;

    .slick-track,
    .slick-list {
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      -o-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .enlargeImage {
    .image_wrapper {
      img {
        width: 100% !important;
        height: auto !important;
        max-height: auto !important;
        min-height: auto !important;
      }
    }

    .slick-arrow {
      z-index: 1200;
    }
  }

  .slick-list {
    width: 100%;
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;

    img {
      border-radius: 8px;
    }

    &:focus {
      outline: none;
    }

    &.dragging {
      cursor: pointer;
      cursor: hand;
    }
  }

  .slick-track {
    min-width: 100%;
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;

    &:before,
    &:after {
      display: table;
      clear: both;
      content: '';
    }
  }

  .slick-loading {
    .slick-track {
      visibility: hidden;
    }

    .slick-slide {
      visibility: hidden;
    }

    .slick-list {
      background: #fff url(${AJAX_LOADER.src}) center center no-repeat;
    }
  }

  .slick-arrow {
    min-width: ${(props) => (props.isCartPromotion ? '29px' : '30px')};
    min-height: ${(props) => (props.isCartPromotion ? '29px' : '30px')};
    background: ${(props) => props.theme.color.white};
    border-radius: 50%;
    box-shadow: 0px 4px 7px rgb(0 0 0 / 12%);
    z-index: 1;

    &:before {
      content: '';
      width: ${(props) => (props.isCartPromotion ? '12px' : '10px')};
      height: ${(props) => (props.isCartPromotion ? '12px' : '20px')};
      background: url(${IC_LEFT_PAGINATION_ARROW.src}) no-repeat 50% 50% / ${(props) => (props.isCartPromotion ? '10px' : '8px')};
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &.slick-disabled {
      display: none !important;
    }

    &.slick-prev {
      left: -10px;

      &.slick-disabled {
        opacity: 0;
      }

      &:before {
        left: calc(50% - 2px);
      }
    }

    &.slick-next {
      right: -10px;

      &:before {
        left: calc(50% + 2px);
        transform: translate(-50%, -50%) rotate(180deg);
      }
    }

    &.slick-disabled {
      display: none !important;
    }

    &.slick-hidden {
      display: none;
    }
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;

    img {
      display: block;
    }

    &.slick-loading {
      img {
        display: none;
      }
    }

    &.dragging {
      img {
        pointer-events: none;
      }
    }
  }

  [dir='rtl'] {
    .slick-slide {
      float: right;
    }

    .slick-next {
      right: auto;
      left: -25px;
    }
    
    .slick-prev {
      right: -25px;
      left: auto;
    }
  }

  .slick-dots {
    display: flex !important;
    justify-content: center;
    z-index: 1;
    bottom: -19px;
    position: absolute;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      width: auto;
      height: auto;
      margin: 0;
      position: relative;
      display: inline-block;
      padding: 0;
      cursor: pointer;

      button {
        width: 17px;
        height: 3px;
        padding: 0;
        margin: 0 6px 0 0;
        background: ${(props) => props?.theme?.blue?.grey};
        border: 0;
        border-radius: 3px;
        transition: 0.2s ease all;
        font-size: 0;
        line-height: 0;
        display: block;
        cursor: pointer;
        color: transparent;
        outline: none;

        &:before {
          display: none;
        }

        &:hover,
        &:focus {
          outline: none;
        }

        &:hover:before,
        &:focus:before {
          opacity: 1;
        }
      }

      &.slick-active {
        button {
          width: 30px;
          background: ${(props) => props.theme.blue.dark};

          &:before {
            opacity: 0.75;
            color: black;
          }
        }
      }
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-initialized {
    .slick-slide {
      display: block;
    }
  }

  .slick-vertical {
    .slick-slide {
      display: block;
      height: auto;
      border: 1px solid transparent;
    }
  }

  @media (max-width: 820px) {
    .slick-list {
      width: 100%;
      margin: 0;
    }
  }

  @media (max-width: 480px) {
    .slick-arrow {
      /* display: none !important; */
      min-width: 30px;
      min-height: 30px;
      background: ${(props) => props.theme.color.white};
      border-radius: 50%;
      box-shadow: 0px 4px 7px ${(props) => props.theme.color.black} 12%;
      z-index: 1;

      &:before {
        content: '';
        width: 10px;
        height: 20px;
        background: url(${IC_LEFT_PAGINATION_ARROW.src}) no-repeat 50% 50% / 8px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &.slick-prev {
        left: -14px;
      }

      &.slick-next {
        right: -12px;

        &:before {
          transform: translate(-50%, -50%) rotate(180deg);
        }
      }
    }
  }

  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    width: 20px;
    height: 20px;
    padding: 0;
    transform: translate(0, -50%);
    border: none;
  }
  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
  }

  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.25;
  }

  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev {
    left: -25px;
  }

  .slick-next {
    right: -25px;
  }
`;
